'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return /*#__PURE__*/function () {
    var _addrs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var peers, _iterator, _step, _step$value, peerId, peerInfo;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              peers = [];
              _iterator = _createForOfIteratorHelper(libp2p.peerStore.peers.entries());

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray(_step.value, 2), peerId = _step$value[0], peerInfo = _step$value[1];
                  peers.push({
                    id: peerId,
                    addrs: peerInfo.multiaddrs.toArray()
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return _context.abrupt("return", peers);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function addrs() {
      return _addrs.apply(this, arguments);
    }

    return addrs;
  }();
};